import { render, staticRenderFns } from "./popconfirm3.vue?vue&type=template&id=2735f1f8"
import script from "./popconfirm3.vue?vue&type=script&lang=js"
export * from "./popconfirm3.vue?vue&type=script&lang=js"
import style0 from "./popconfirm3.vue?vue&type=style&index=0&id=2735f1f8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports